import { Link } from 'react-router-dom'
import { Input, InputPassword, EMAIL_VALIDATION, PASSWORD_VALIDATION } from '@/common/ui/Form'
import { Fieldset } from '@/common/ui/Form/Fieldset/Fieldset'
import { Button } from '@/common/ui/Form/Button'
import { Checkbox } from '@/common/ui/Form/Checkbox'
import { useRegister } from '../../model'
import { AuthTabs } from '../shared/AuthTabs'
import { ROUTES } from '../../lib/constants'

export const RegistrationForm = () => {
    const { register, handleSubmit, errors, onSubmit, mutation, email } = useRegister()

    return (
        <form
            onSubmit={handleSubmit(onSubmit)}
            aria-label='Форма регистрации'
            className='w-full flex flex-col gap-[1.875rem]'
        >
            {email && (
                <>
                    <span className='block text-[1.25rem] mb-[0.938rem]'>Подтвердите почту</span>
                    <p>
                        Мы отправили письмо Вам на почту
                        <br />
                        <strong>{email}</strong>.<br />
                        Перейдите по ссылке, чтобы активировать аккаунт.
                    </p>
                    <Link to={ROUTES.AUTH.LOGIN} className='underline'>
                        Вернуться на страницу входа
                    </Link>
                </>
            )}
            {!email && (
                <>
                    <AuthTabs />
                    <Fieldset errorText={errors.email?.message} required>
                        <Input
                            size='lg'
                            type='text'
                            placeholder='Email'
                            className='input w-full'
                            {...register('email', {
                                required: EMAIL_VALIDATION.required,
                                pattern: EMAIL_VALIDATION.pattern,
                            })}
                        />
                    </Fieldset>
                    <Fieldset errorText={errors.password?.message} required>
                        <InputPassword
                            size='lg'
                            placeholder='Пароль'
                            className='w-full'
                            aria-label='Пароль'
                            autoComplete='off'
                            {...register('password', { required: PASSWORD_VALIDATION.required })}
                        />
                    </Fieldset>
                    <Fieldset errorText={errors.password_confirm?.message} required>
                        <InputPassword
                            size='lg'
                            placeholder='Подтвердите пароль'
                            className='w-full'
                            aria-label='Подтвердите пароль'
                            autoComplete='off'
                            {...register('password_confirm', { required: PASSWORD_VALIDATION.required })}
                        />
                    </Fieldset>
                    <div className='mt-4'>
                        Пароль должен быть не менее 8 символов и содержать хотя бы один заглавный, строчный и цифровой
                        символ
                    </div>
                    <Fieldset>
                        <Checkbox
                            id='subscribe-marketing'
                            aria-label='Согласие на рассылки'
                            {...register('subscribe_marketing')}
                        />
                        <label htmlFor='subscribe-marketing' className='ml-2'>
                            Согласен получать рекламные и информационные рассылки
                        </label>
                    </Fieldset>
                    <Fieldset errorText={errors.terms_of_service?.message} required>
                        <Checkbox
                            id='terms-of-service'
                            {...register('terms_of_service', {
                                required: 'Необходимо согласиться с условиями пользовательского соглашения',
                            })}
                        />
                        <label htmlFor='terms-of-service' className='ml-2'>
                            Согласен с условиями{' '}
                            <a href='/eula.pdf' target='_blank' className='underline whitespace-nowrap'>
                                публичной оферты
                            </a>{' '}
                            и подтверждаю свое согласие с{' '}
                            <a href='/privacy.pdf' target='_blank' className='underline'>
                                политикой в отношении обработки персональных данных
                            </a>
                            .
                        </label>
                    </Fieldset>

                    {errors.root && (
                        <div className='input-error text-center text-sm text-error'>{errors.root.message}</div>
                    )}
                    <Button
                        variant='filled'
                        emphasis='accent'
                        size='xl'
                        className='w-full'
                        type='submit'
                        disabled={mutation.isPending}
                        loading={mutation.isPending}
                    >
                        Зарегистрироваться
                    </Button>
                </>
            )}
        </form>
    )
}
